var flatten = require('flat')
var messages = require('../src/i18n/messages.js')

var flatData = flatten(messages)

var dataString
for (var prop in flatData) {
  dataString += flatData[prop]
}

dataString = dataString.replace(/(\r\n|\n|\r|\[|\]|\s')/gm, '')

dataString = dataString.replace(/(.)(?=.*\1)/g, "");

var alphabet = 'abcdefghijklmnopqrstuvwxyz'
var digits = '0123456789'
dataString += alphabet
dataString += alphabet.toUpperCase()
dataString += digits

module.exports = dataString
// return dataString



//////////////////
// WEBPACK FOOTER
// ./build/fontSubsetData.js
// module id = 606
// module chunks = 1